import {request,post} from '@/utils/request.js'
export  const testForUser =  () => request('/api/index/product?t=legend')
//登录接口 默认账号密码 Findtrader@outlook.com  123123
// @ts-ignore
export const login  =(params)=> request('/api/base/pwdlogin',{data:params,...post})
export const smsLogin  =(params)=> request('/api/base/dosmslogin',{data:params,...post})

//发送邮箱验证码
export const sendEmailCode = ({email, sign})=> request('/api/base/sendemail',{data:{email, sign},...post})
//找回密码-发送邮件验证码
export const sendEmailCodeForPwd = ({email, sign})=> request('/api/base/usersendemail',{data:{email, sign},...post})
//执行找回密码
export const findPwd = data => request('/api/base/dofgpwd',{data,...post})
//退出登录
export  const outLogin =  () => request('/api/base/logout')

//注册接口
export const register = data => request('/api/base/doreg',{data,...post})

//获取用户信息
export const queryCurrentUser = () =>request('/api/user/userinfo')

//修改个人信息
export const updateUserInfo = (data={}) => request('/api/user/infoup',{data,...post})
//获取账户信息
export const getAccountInfo = () => request('/api/user/accountinfo')

// 谷歌在线翻译
export const getGoogleLang = data => request('/api/translate/index',{data,...post})

//获取用户实名认证状态
export const getAuthStatus = () =>request('/api/user/authstatus')
//修改认证信息
export const updateUserAuthInfo = (data={}) => request('/api/user/auth',{data,...post})

//修改认证证件信息
export const uploadUserDocuments = (data={}) => request('/api/user/authsteptwo',{data,...post})
//上传证件
export const uploadFile = (file) => {
    const formData = new FormData();
    formData.append('card', file);
    return request('/api/user/imgupload', {
        ...post,
        data: formData,
    });
};
